export const TRAVEL_UG_EMPLOYEE_DETAILS_FORM = 'travelUg/employeeDetailsFrom/';

export const TRAVEL_UG_EMPLOYEE_DETAILS_FORM_SET_VALUE = TRAVEL_UG_EMPLOYEE_DETAILS_FORM + 'setValue';
export const TRAVEL_UG_EMPLOYEE_DETAILS_FORM_SET_VALID = TRAVEL_UG_EMPLOYEE_DETAILS_FORM + 'setValid';

export const FORM_VALID_TRAVEL_UG_EMPLOYEE_DETAILS_FORM = 'travelUg/employeeDetailsFrom/transition/formValid';
export const FORM_INVALID_TRAVEL_UG_EMPLOYEE_DETAILS_FORM = 'travelUg/employeeDetailsFrom/transition/formInValid';

export const REINITIALIZE_FORM = 'travelUg/employeeDetailsFrom/state/reinitialize/form';
export const REINITIALIZE_EMPLOYEES = 'travelUg/employeeDetailsFrom/state/reinitialize/employees';

export const transitionTravelUgEmployeeDetails = {
    formValid: () => ({
        type: FORM_VALID_TRAVEL_UG_EMPLOYEE_DETAILS_FORM,
    }),
    formInvalid: () => ({
        type: FORM_INVALID_TRAVEL_UG_EMPLOYEE_DETAILS_FORM,
    }),
};

export const FIRST_NAME_SET_VALUE = TRAVEL_UG_EMPLOYEE_DETAILS_FORM_SET_VALUE + 'firstName';
export const FIRST_NAME_SET_VALID = TRAVEL_UG_EMPLOYEE_DETAILS_FORM_SET_VALID + 'firstName';

export const SURNAME_SET_VALUE = TRAVEL_UG_EMPLOYEE_DETAILS_FORM_SET_VALUE + 'surname';
export const SURNAME_SET_VALID = TRAVEL_UG_EMPLOYEE_DETAILS_FORM_SET_VALID + 'surname';

export const DOB_SET_VALUE = TRAVEL_UG_EMPLOYEE_DETAILS_FORM_SET_VALUE + 'dateOfBirth';
export const DOB_SET_VALID = TRAVEL_UG_EMPLOYEE_DETAILS_FORM_SET_VALID + 'dateOfBirth';

export const EMPLOYMENT_DATE_SET_VALUE = TRAVEL_UG_EMPLOYEE_DETAILS_FORM_SET_VALUE + 'employmentDate';
export const EMPLOYMENT_DATE_SET_VALID = TRAVEL_UG_EMPLOYEE_DETAILS_FORM_SET_VALID + 'employmentDate';

export const MOBILE_NUMBER_SET_VALUE = TRAVEL_UG_EMPLOYEE_DETAILS_FORM_SET_VALUE + 'mobileNumber';
export const MOBILE_NUMBER_SET_VALID = TRAVEL_UG_EMPLOYEE_DETAILS_FORM_SET_VALID + 'mobileNumber';

export const ID_PASSPORT_SET_VALUE = TRAVEL_UG_EMPLOYEE_DETAILS_FORM_SET_VALUE + 'idPassportNumber';
export const ID_PASSPORT_SET_VALID = TRAVEL_UG_EMPLOYEE_DETAILS_FORM_SET_VALID + 'idPassportNumber';

export const TIN_NUMBER_SET_VALUE = TRAVEL_UG_EMPLOYEE_DETAILS_FORM_SET_VALUE + 'tinNumber';
export const TIN_NUMBER_SET_VALID = TRAVEL_UG_EMPLOYEE_DETAILS_FORM_SET_VALID + 'tinNumber';

export const EMPLOYEES_SET_VALUE = TRAVEL_UG_EMPLOYEE_DETAILS_FORM_SET_VALUE + 'employees';
export const EMPLOYEES_SET_VALID = TRAVEL_UG_EMPLOYEE_DETAILS_FORM_SET_VALID + 'employees';

export const EDIT_EMPLOYEE_VALUE = TRAVEL_UG_EMPLOYEE_DETAILS_FORM_SET_VALUE + 'edit';
export const EDIT_EMPLOYEE_VALID = TRAVEL_UG_EMPLOYEE_DETAILS_FORM_SET_VALID + 'edit';

export const FILE_UPLOADED_SET_VALUE = TRAVEL_UG_EMPLOYEE_DETAILS_FORM_SET_VALUE + 'fileCsv';
export const FILE_UPLOADED_SET_VALID = TRAVEL_UG_EMPLOYEE_DETAILS_FORM_SET_VALID + 'fileCsv';

export const setFirstNameValue = (value) => ({
    type: FIRST_NAME_SET_VALUE,
    value,
});

export const setFirstNameValid = (error) => ({
    type: FIRST_NAME_SET_VALID,
    error,
});

export const setSurnameValue = (value) => ({
    type: SURNAME_SET_VALUE,
    value,
});

export const setSurnameValid = (error) => ({
    type: SURNAME_SET_VALID,
    error,
});

export const setDoBValue = (value) => ({
    type: DOB_SET_VALUE,
    value,
});

export const setDoBValid = (error) => ({
    type: DOB_SET_VALID,
    error,
});

export const setEmployementDateValue = (value) => ({
    type: EMPLOYMENT_DATE_SET_VALUE,
    value,
});

export const setEmployementDateValid = (error) => ({
    type: EMPLOYMENT_DATE_SET_VALID,
    error,
});

export const setMobileNumberValue = (value) => ({
    type: MOBILE_NUMBER_SET_VALUE,
    value,
});

export const setMobileNumberValid = (error) => ({
    type: MOBILE_NUMBER_SET_VALID,
    error,
});

export const setIdPassortNumberValue = (value) => ({
    type: ID_PASSPORT_SET_VALUE,
    value,
});

export const setIdPassortNumberValid = (error) => ({
    type: ID_PASSPORT_SET_VALID,
    error,
});

export const setTinNumberValue = (value) => ({
    type: TIN_NUMBER_SET_VALUE,
    value,
});

export const setTinNumberValid = (error) => ({
    type: TIN_NUMBER_SET_VALID,
    error,
});

export const setEmployeesValue = (value) => ({
    type: EMPLOYEES_SET_VALUE,
    value,
});

export const setEmployeesValid = (error) => ({
    type: EMPLOYEES_SET_VALID,
    error,
});

export const setFormToInitial = () => ({
    type: REINITIALIZE_FORM,
});

export const setEditEmployee = (value) => ({
    type: EDIT_EMPLOYEE_VALUE,
    value,
});

export const setFileCsv = (value) => ({
    type: FILE_UPLOADED_SET_VALUE,
    value,
});
